export default {
  appVersion: state => {
    return state.version;
  },
  isAuthenticated(state) {
    return state.user !== null && state.user !== undefined;
  }
};
